export default function () {

    const name = 'Tauschwohnung GmbH'
    const street = 'Graf-von-Lehndorff-Str. 12'
    const postalCode = '53175'
    const city = 'Bonn'
    const email = 'info@tauschwohnung.com'
    const phone = ''

    return {
        name,
        street,
        postalCode,
        city,
        email,
        phone
    }
}